import Footer1 from './Variants/Footer1'

export const ContentDirections = {
	left: 'asc',
	right: 'desc',
	center: null,
}

export const TextPositions = {
	left: 'right',
	right: 'left',
	center: 'left',
}

export const FOOTER_VARIANTS = {
	VARIANT_1: 'footer-1',
}

export const ELEMENT_VARIANTS = {
	[FOOTER_VARIANTS.VARIANT_1]: Footer1,
}
